module.exports = __webpack_public_path__ + "01_veryshort_black.0a4b6e32.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer5/01_veryshort_black.png
// module id = 0H4b
// module chunks = 0